


import { JSONSchema6 } from 'json-schema';
import { EObservationStatus } from '../interfaces/IObservation';


export interface ISchemaContext {
    roles: string[];
    canViewNames: boolean;
    mode: "display" | "form",
    status: EObservationStatus,
    allowChangingProcessingMarkingPublicity: boolean;
    emptyValue?: string;
}

export const contextSchema: JSONSchema6 = {
    "type": "object",
    "properties": {
        "roles": {
            "type": "array",
            "items": {
                "type": "string"
            }
        },
        "canViewNames": {
            "type": "boolean"
        },
        "mode": {
            "type": "string",
            "enum": ["display", "form"]
        },
        "status": {
            "type": "string",
            "enum": ["uusi", "kasittelyssa", "kasitelty"]
        },
        "allowChangingProcessingMarkingPublicity": {
            "type": "boolean"
        }
    }
}
